import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { getCookie, setCookie } from '../../utils/cookies';

export const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [theme, setTheme] = useState(() => getCookie('tg_prime_theme') || 'dark');

  useLayoutEffect(() => {
    if (theme === 'light') {
      document.body.classList.add('light-theme');
    } else {
      document.body.classList.remove('light-theme');
    }
    setCookie('tg_prime_theme', theme, 365);
  }, [theme]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  const handleLoginSuccess = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    setUser(null);
  };

  const handleOpenAuth = () => {
    navigate('/auth');
  };

  const isAuthPage = location.pathname === '/auth';

  return (
    <div className="App">
      {!isAuthPage && (
        <Navbar 
          onOpenAuth={handleOpenAuth} 
          user={user} 
          onLogout={handleLogout}
          theme={theme}
          onToggleTheme={toggleTheme}
        />
      )}
      
      <Outlet context={{ handleLoginSuccess }} />

      {!isAuthPage && <Footer />}
    </div>
  );
};

export default Layout;